import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var AppConfigService = /** @class */ (function () {
    function AppConfigService(http) {
        var _this = this;
        this.http = http;
        this.load = function () {
            var jsonFile = "assets/config/config." + environment.name + ".json";
            return new Promise(function (resolve, reject) {
                _this.http.get(jsonFile).toPromise().then(function (response) {
                    _this._settings = response;
                    _this._settings.version = JSON.parse(localStorage.getItem('Version'));
                    resolve(_this.settings);
                }).catch(function (response) {
                    reject("Could not load file '" + jsonFile + "': " + JSON.stringify(response));
                });
            });
        };
    }
    Object.defineProperty(AppConfigService.prototype, "settings", {
        get: function () {
            return this._settings;
        },
        enumerable: true,
        configurable: true
    });
    AppConfigService.ngInjectableDef = i0.defineInjectable({ factory: function AppConfigService_Factory() { return new AppConfigService(i0.inject(i1.HttpClient)); }, token: AppConfigService, providedIn: "root" });
    return AppConfigService;
}());
export { AppConfigService };
